import { render } from "./diabetes_list.vue?vue&type=template&id=e951a352&scoped=true"
import script from "./diabetes_list.vue?vue&type=script&lang=js"
export * from "./diabetes_list.vue?vue&type=script&lang=js"

import "./diabetes_list.vue?vue&type=style&index=0&id=e951a352&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e951a352"]])

export default __exports__